import { Component } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-footer',
  imports: [TegelModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

}
